export const checkCookieExist = (cookieName) => {
    return document.cookie.indexOf(cookieName);
}

// Set cookie - cookie name, expired time in days
export const setCookie = (cookieName, expiredDays) => {
    let expires = new Date();
    expires.setTime(expires.getTime() + (expiredDays*24*60*60*1000));
    document.cookie = `${cookieName}=yes;expires=${expires};path=/`;
}

// Export defoult cookies function
export default () => {
    if(checkCookieExist('quacookies') < 0) {
        $('#cookies-box').show();
    }

    $('.cookies-box-close').on('click', () => {
        console.log('Close cookie');
        setCookie('quacookies', 30);
        $('#cookies-box').hide();
    });
}